import { useEffect } from 'react';
import { UiCommon } from '@/common/common';
import styles from './StartPopup.module.scss';
import icoPopupClose from '../../assets/images/icon/ico_popup_close.svg';
import icoStep1 from '../../assets/images/icon/ico_popup_step1.svg';
import icoStep2 from '../../assets/images/icon/ico_popup_step2.svg';
import icoStep3 from '../../assets/images/icon/ico_popup_step3.svg';
import icoStep4 from '../../assets/images/icon/ico_popup_step4.svg';
import icoStep5 from '../../assets/images/icon/ico_popup_step5.svg';

interface StartPopupProps {
	onClose: () => void;
}

const steps = [
	{ num: 1, title: '회원가입', icon: icoStep1 },
	{ num: 2, title: '로그인', icon: icoStep2 },
	{ num: 3, title: '요금제선택', icon: icoStep3 },
	{ num: 4, title: '자동이체 계좌 등록', icon: icoStep4 },
	{ num: 5, title: '무료사용', icon: icoStep5 }
];

const tips = [
	{
		bold: '무료 2개월 사용 :',
		text: '가입 월 포함 ',
		red: '최대 2개월간 무료로 이용',
		after: '할 수 있으며, 무료 사용 기간엔 비용 청구되지 않습니다.'
	},
	{
		bold: '유료 버전과 동일 서비스 제공 :',
		text: '무료 사용 기간에도 게시판 문의, 전화 응대, 원격 지원 등의 ',
		red: '유료 버전과 동일한 고객지원 서비스를 제공',
		after: '합니다.'
	},
	{ bold: '무료 종료 사전 안내 :', text: '무료 사용 ', red: '종료 7일 전, 출금 안내 문자', after: '를 보내드립니다.' },
	{ bold: '해지는 언제든 자유 :', text: '가입 월 포함 ', red: '언제든지 해지', after: '할 수 있습니다.' }
];

const StartPopup = ({ onClose }: StartPopupProps) => {
	useEffect(() => {
		const html = document.documentElement;
		const body = document.body;
		html.style.overflow = 'hidden';
		body.style.overflow = 'hidden';

		return () => {
			html.style.overflow = '';
			body.style.overflow = '';
		};
	}, []);

	return (
		<div className={styles.overlay} onClick={onClose}>
			<div className={styles['popup-wrap']} onClick={e => e.stopPropagation()}>
				<button type="button" className={styles['popup-wrap__close']} onClick={onClose}>
					<img src={icoPopupClose} alt="닫기" />
				</button>
				<div className={styles.popup}>
					<div className={styles['popup__title']}>
						<p>우리 회사를 위한 최고의 ERP!</p>
						<p>스타트업 성장 지원 플랫폼 스텔라에 오신것을 환영합니다. </p>
					</div>

					<p className={styles['popup__subtitle']}>
						지금 회원 가입하시면 스텔라의 모든 기능을 <b>최대 2개월간 무료</b>로 사용할 수 있습니다.
					</p>

					<div className={styles['popup__process']}>
						<div className={styles['popup__process-line']} />
						{steps.map(step => (
							<div key={step.num} className={styles['popup__step']}>
								<div className={styles['popup__step-head']}>
									<span className={`${styles['popup__step-badge']} ${styles[`popup__step-badge--${step.num}`]}`}>
										{step.num}
									</span>
									<span className={styles['popup__step-name']}>{step.title}</span>
								</div>
								<span className={`${styles['popup__step-dot']} ${styles[`popup__step-dot--${step.num}`]}`} />
								<img className={styles['popup__step-icon']} src={step.icon} alt={step.title} />
							</div>
						))}
					</div>

					<div className={styles['popup__tips']}>
						{tips.map((tip, i) => (
							<div key={i} className={styles['popup__tip']}>
								<span className={styles['popup__tip-emoji']}>💡</span>
								<p className={styles['popup__tip-text']}>
									<b>{tip.bold}</b> {tip.text}
									<span className={styles['popup__tip-red']}>{tip.red}</span>
									{tip.after}
								</p>
							</div>
						))}
					</div>

					<a
						className={styles['popup__btn']}
						onClick={() => UiCommon.goStellaService('/views/US/01/US-01-220.html')}
						target="_blank"
						rel="noopener noreferrer"
						id={'serviceJoin'}>
						회원 가입
					</a>
				</div>
			</div>
		</div>
	);
};

export default StartPopup;
